/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import { createSearchParams, useNavigate } from "react-router-dom";
import classNames from "classnames";

// Constants
import { GET_PARAMS, GET_POPUP_TYPES } from "constants/popupConfig";

// Hooks
import { useGTM } from "hooks/useGTM";
import useFormatBonusBalance from "hooks/useFormatBonusBalance";
import useFormatBalance from "hooks/useFormatBalance";

// Icons
import PlusIcon from "assets/icons/glory/plus.svg?react";
import BonusIcon from "assets/icons/bonus.svg?react";

import "./styles.sass";

type UserControlsAuthProps = {
  balance: number;
  bonus: number;
};

const WalletControls = (props: UserControlsAuthProps) => {
  const { balance, bonus } = props;
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const GTM = useGTM();
  const navigate = useNavigate();
  const formatBonus = useFormatBonusBalance();
  const formatBalance = useFormatBalance();

  const handleDeposit = () => {
    GTM.openDeposit();
    navigate({
      search: `?${createSearchParams({ [GET_PARAMS.POPUP]: GET_POPUP_TYPES.popup.deposit })}`,
    });
  };

  const BackgroundClass = classNames("WalletControls", {
    // eslint-disable-next-line camelcase
    WalletControls_banger: VITE_APP_PROJECT_NAME === "banger",
  });

  return (
    <div
      className={BackgroundClass}
      onClick={handleDeposit}
      data-cy="wallet-controls"
    >
      <div className="WalletControls__balance">
        <div className="WalletControls__balance_currency">
          {formatBalance(balance)}
        </div>
        <div className="WalletControls__balance_bonus">
          <span>
            <BonusIcon />
          </span>
          {formatBonus(bonus)}
        </div>
      </div>
      <button className="WalletControls__wallet">
        <PlusIcon />
      </button>
    </div>
  );
};

export default WalletControls;
